import '@adornis/adornis-components/a-swipe';

import { AdornisRouter } from '@adornis/base/client/a-router';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { BehaviorController } from '@adornis/chemistry/controllers/behavior-controller';
import { SizeController } from '@adornis/chemistry/controllers/size-controller';
import { css } from '@adornis/chemistry/directives/css';
import { preload } from '@adornis/chemistry/directives/preload';
import '@adornis/chemistry/elements/components/x-icon';
import { Renderable } from '@adornis/chemistry/renderable';
import '@adornis/file-utils/client/x-image';
import '@adornis/germanium/components/ge-section';
import { GhostData } from '@adornis/ghost/db/ghost';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

@customElement('wtg-swipe')
export class WTGSwipe extends ChemistryLitElement {
  styles = () => ({ ':host': { display: 'block', position: 'relative' } });
  size = new SizeController(this);

  @state() currIndex = 0;

  @state() blogPosts = new BehaviorController<GhostData[]>(this, []);

  forward() {
    if (this.currIndex >= this.blogPosts.value.length - 1) {
      this.currIndex = 0;
    } else {
      this.currIndex = this.currIndex + 1;
    }
  }

  backward() {
    if (this.currIndex <= 0) {
      this.currIndex = this.blogPosts.value.length - 1;
    } else {
      this.currIndex = this.currIndex - 1;
    }
  }

  override render() {
    let currBlogPost = this.blogPosts.value[this.currIndex];

    if (!currBlogPost) return nothing;

    return html`
      <x-flex
        padding="sm"
        horizontal
        space="sm"
        center
        ${css({
          position: 'absolute',
          bottom: this.spacing.md,
          zIndex: '2',

          userSelect: 'none',
          left: '0',
          right: '0',
          textAlign: 'center',
        })}
      >
        ${repeat(
          this.blogPosts.value,
          (_, i) =>
            html`
              <x-flex
                @click=${() => (this.currIndex = i)}
                ${css({
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                })}
              >
              </x-flex>
            `,
        )}
      </x-flex>

      <x-flex
        padding="sm"
        ${css({
          backgroundColor: 'rgba(255,255,255, .6)',
          position: 'absolute',
          left: this.spacing.md,
          borderRadius: '50%',
          top: '45%',
          zIndex: '2',
          cursor: 'pointer',
          userSelect: 'none',
        })}
        @click=${() => this.backward()}
      >
        <img
          ${css({
            width: '30px',
            height: '30px',
          })}
          src=${require('client/assets/arrow_back.svg')}
        />
      </x-flex>

      <x-flex
        crossaxis-center
        center
        padding="sm"
        ${css({
          backgroundColor: 'rgba(255,255,255, .6)',
          position: 'absolute',
          right: this.spacing.md,
          borderRadius: '50%',
          top: '45%',

          zIndex: '2',
          cursor: 'pointer',
          userSelect: 'none',
        })}
        @click=${() => {
          this.forward();
        }}
      >
        <img
          ${css({
            width: '30px',
            height: '30px',
            transform: 'rotate(180deg)',
          })}
          src=${require('client/assets/arrow_back.svg')}
        />
      </x-flex>

      <x-flex
        ?horizontal=${!this.size.isMobile}
        end
        ${css({
          position: 'relative',
          borderRadius: this.sizes.borderRadius,
          color: this.colors.on.secondary,
          overflow: 'hidden',
          zIndex: '1',
          height: '100%',
        })}
      >
        <x-flex ${css({ zIndex: '1', position: 'absolute', left: '0', width: '100%', height: '100%' })}>
          ${preload(
            this.blogPosts.value.reduce(
              (acc, curr, i) => {
                acc[i.toString()] = () =>
                  html`
                    <img
                      ${css({ height: '100%', width: '90%', objectFit: 'cover', objectPosition: 'left top' })}
                      src="${curr.featureImage}"
                    />
                  `;

                return acc;
              },
              {} as {
                [page: string]: () => Renderable;
              },
            ),
            this.currIndex.toString(),
            true,
          )}
        </x-flex>

        <img
          ${css({
            width: '302px',
            position: 'absolute',
            right: '10%',
            bottom: '-100px',
            zIndex: '10',
          })}
          src=${require('client/assets/svgs_home/Pattern.svg')}
        />

        <x-flex
          space="lg"
          padding="xl"
          center
          crossaxis-end
          ${css({
            width: '100%',
            position: 'relative',
            zIndex: '3',
            background: `linear-gradient(${this.size.isMobile ? '195deg' : '105deg'}, transparent 30%, ${
              this.colors.accent
            } 50%)`,
          })}
        >
          <x-flex
            ${css(this.size.isMobile ? { width: '100%', height: '50%' } : { width: '50%', height: '100%' })}
            center
            padding="md"
            space="lg"
          >
            <ge-h3> ${currBlogPost.title} </ge-h3>
            <ge-text> ${currBlogPost.excerpt} </ge-text>

            <x-flex
              horizontal
              space="sm"
              crossaxis-center
              @click=${() => {
                AdornisRouter.goTo(`/blog/post/${currBlogPost?.id}`);
              }}
              ${css({ cursor: 'pointer', userSelect: 'none' })}
            >
              <img
                ${css({
                  width: '20px',
                })}
                src=${require('client/assets/plus_square_white.svg')}
              />
              <ge-text> SEE MORE </ge-text>
            </x-flex>
          </x-flex>
        </x-flex>
      </x-flex>
    `;
  }
}
